export const WIDGET_EVENTS = {
  CHANGE: 'change',
  SUBMIT: 'submit',
  NESTED_FIELD_CHANGE: 'nested-field-change',
};
